











































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { ClaimsPageRequestSortableColumn } from "@/shared/types";
import HsabImportedClaimColumnHeader from "@/employee/components/hsabExpenses/HsabImportedClaimColumnHeader.vue";

@Component({
  components: { HsabImportedClaimColumnHeader },
  computed: {
    ClaimsPageRequestSortableColumn () {
      return ClaimsPageRequestSortableColumn;
    }
  }
})
export default class HsabImportedClaimColumns extends Vue {
  SortableColumn = ClaimsPageRequestSortableColumn;
  @Prop() hideLinkAndCreateFeatures: boolean;
}
